import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/(shop)/ClientContentLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/(shop)/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AmplitudeSessionReplay"] */ "/vercel/path0/src/components/analytics/AmplitudeSessionReplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/analytics/MoonshotAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/base.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.scss");
